import { Box, ListItemButton } from '@mui/material'
import { t } from 'i18next'

import Alert from 'src/components/shared/ui/Alert'
import { InfoLxFillIcon, WarningFillIcon } from 'src/components/shared/ui/Icons'

import { theme } from 'src/providers/ThemeProvider'

type Props = {
  onClickVerify: () => void
  firmadoEnOrigen?: boolean
  pendienteDescarga?: boolean
  downloading?: boolean
}

const styles = {
  alert: {
    marginTop: '16px',
    padding: theme.spacing(1, 1.5),

    '& .MuiAlert-message': {
      padding: '2px 0 0 0'
    }
  },

  title: {
    fontFamily: theme.corporate.primaryFont,
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    marginBottom: '5px'
  },

  button: {
    width: 'fit-content',
    padding: '8px 0',
    color: theme.colors.byzantineBlue200,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',

    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline'
    }
  }
}

export default function VerificacionLectura({
  onClickVerify,
  firmadoEnOrigen,
  pendienteDescarga,
  downloading
}: Props): JSX.Element {
  const soloDescargar = firmadoEnOrigen || pendienteDescarga

  function renderIconType(): JSX.Element {
    if (firmadoEnOrigen) {
      return <InfoLxFillIcon htmlColor={theme.colors.blue01} />
    }
    return <WarningFillIcon sx={{ fontSize: '22px' }} htmlColor={theme.colors.saffron200} />
  }

  function renderText(): string {
    if (pendienteDescarga) {
      return t('alert.pendiente_descarga')
    }
    if (firmadoEnOrigen) {
      return t('alert.firmado_en_origen')
    }
    return t('alert.operativa_lexnet_mensaje_warning')
  }

  function renderButtonLabel(): string {
    if (downloading) {
      return t('actions.downloading')
    }
    return soloDescargar ? t('actions.download_message') : t('actions.sign')
  }

  return (
    <Alert severity={firmadoEnOrigen ? 'info' : 'warning'} sx={styles.alert} icon={renderIconType()}>
      <Box sx={styles.title}> {t('alert.verificacion')}</Box>
      <Box>{renderText()}</Box>
      <ListItemButton sx={styles.button} onClick={onClickVerify} disabled={downloading}>
        {renderButtonLabel()}
      </ListItemButton>
    </Alert>
  )
}
